<span class="example" [innerHTML]="data.message" data-test-id="snackbar.message-value">
<!-- </span>
<span matSnackBarActions>
  <button data-test-id="snackbar.action-button" mat-stroked-button matSnackBarAction (click)="snackBarRef.dismiss()" [innerHTML]="data.action"></button> -->
</span>
